import getContainers from '../../api/cars/getContainers';
import Select from '../Select/Select';
import usePaginatedSelect from '../../hooks/usePaginatedSelect';

const fetchFn = (page) => getContainers({ page });
const extractItems = (res) => res.data.containers;
const formatOption = (item) => ({ value: item.id, label: item.mark.name + ' ' + item.model.name });

const SelectContainers = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const { data, isLoading, loadMore } = usePaginatedSelect({ fetchFn, extractItems, formatOption });

  const handleGetSelectVar = (val) => {
    if (val != '' && val != null) getContainers({ markAndModel: val });
  };

  return (
    <Select
      handleSetSelect={(val) => {
        handleSetSelect && handleSetSelect(val);
        handleGetSelectVar(val);
      }}
      handleSetState={handleSetState}
      options={data}
      title={'ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      onFocus={loadMore}
      style={style}
      isLoading={isLoading}
      isSearchable
      {...props}
    />
  );
};

export default SelectContainers;
